export default "__VITE_ASSET__a675a105__"